import { GridLegacy, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { SxProps, useTheme } from '@mui/material/styles';
import { PartTypeProps } from 'ui-component/CreateNewOrgPartDialog/constants';
import { OrgPartType } from 'types/clientV2/parts';
import Chip, { ChipColor } from 'ui-component/extended/Chip';

type ClickableBoxProps = {
  boxProps: PartTypeProps;
  isSelected: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  sx?: SxProps;
} & (
  | { disabled: true; onClick?: (id: OrgPartType) => void }
  | { disabled?: false; onClick: (id: OrgPartType) => void }
);

const ClickableBox: FC<ClickableBoxProps> = ({
  onClick,
  boxProps,
  isSelected,
  disabled,
  disabledMessage = 'Coming Soon',
  sx,
}) => {
  const theme = useTheme();
  const { id, Icon, label, description } = boxProps;
  return (
    <Tooltip title={disabled ? disabledMessage : undefined}>
      <GridLegacy
        container
        onClick={() => !disabled && onClick(id as OrgPartType)}
        sx={{
          cursor: disabled ? 'inherit' : 'pointer',
          height: { xs: '150px', md: '125px' },
          border: '1px solid',
          borderColor: theme.palette.divider,
          bgcolor: theme.palette.background.paper,
          color: disabled ? theme.palette.text.disabled : 'inherit',
          opacity: disabled ? 0.6 : 1,
          ...(isSelected && {
            bgcolor: theme.palette.primary.light,
          }),
          ...sx,
        }}
        alignItems="center"
        justifyContent="space-around"
      >
        <GridLegacy
          item
          container
          justifyContent="center"
          sx={{
            p: 2,
          }}
          xs={2}
        >
          <Icon size={28} aria-label={label} />
        </GridLegacy>
        <GridLegacy
          item
          sx={{
            p: 2,
          }}
          xs={10}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            {label}{' '}
            {disabled && (
              <Chip
                style={{ textTransform: 'uppercase' }}
                label={disabledMessage}
                chipcolor={ChipColor.secondary}
              />
            )}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              lineHeight: 1.3,
            }}
          >
            {description}
          </Typography>
        </GridLegacy>
      </GridLegacy>
    </Tooltip>
  );
};

export default ClickableBox;
